import { ApplicationFormAnswers, PersonalDetailsType } from '../../../components/ApplicationForm/ApplicationFormContext'
import { VehicleDetailsDataObject } from '../../../services/vehicle-service'
import { Mapper, Ctx } from '../core/types'
import { mapAddressHistoryDefault } from '../domain/address'
import { mapEmploymentHistoryDefault } from '../domain/employment'
import { keepValue } from '../dsl/blocks'

export const defaultMappers = {
    addressHistory: ((_: any, ctx: Ctx) => mapAddressHistoryDefault(ctx.answers)) as Mapper<ApplicationFormAnswers['addressHistory']>,
    contactNumber: keepValue<string>(),
    drivingLicence: keepValue<string>(),
    emailAddress: keepValue<string>(),
    employmentHistory: ((_: any, ctx: Ctx) => mapEmploymentHistoryDefault(ctx.answers)) as Mapper<ApplicationFormAnswers['employmentHistory']>,
    loanAmount: keepValue<string>(),
    maritalStatus: keepValue<string>(),
    monthlyIncome: keepValue<number>(),
    personalDetails: ((v: PersonalDetailsType) => ({
        title: v.title,
        dateOfBirth: v.dateOfBirth,
        firstName: v.firstName,
        surname: v.surname,
        contactNumber: v.contactNumber,
        emailAddress: v.emailAddress
    })) as Mapper<ApplicationFormAnswers['personalDetails']>,
    vehicleType: keepValue<string>(),
    vehicleDetails: keepValue<VehicleDetailsDataObject>()
}


